/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export type Alignment = 'begin' | 'end' | 'center' | 'stretch' | 'left' | 'right' | 'top' | 'bottom';

export class Alignments {
  static readonly BEGIN: Alignment = 'begin';
  static readonly END: Alignment = 'end';
  static readonly CENTER: Alignment = 'center';
  static readonly STRETCH: Alignment = 'stretch';
  static readonly LEFT: Alignment = 'left';
  static readonly RIGHT: Alignment = 'right';
  static readonly TOP: Alignment = 'top';
  static readonly BOTTOM: Alignment = 'bottom';
}
